export const environment = {
    production: true,
    apiBaseUrl: "https://mobile.test.firsty.app",
    partnerAreaBaseUrl: "https://partner-area.test.firsty.app"
};
